export function ListItemSecondIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2.375C5.5125 2.375 1.875 6.0125 1.875 10.5C1.875 14.9875 5.5125 18.625
        10 18.625C14.4875 18.625 18.125 14.9875 18.125 10.5C18.125 6.0125 14.4875 2.375
        10 2.375ZM12.7137 13.2663V14.7019H7.30375C7.36187 14.16 7.5375 13.6469 7.83063
        13.1612C8.12313 12.6762 8.70125 12.0319 9.56438 11.23C10.2588 10.5819 10.685
        10.1425 10.8425 9.91188C11.055 9.59313 11.1612 9.27812 11.1612 8.96687C11.1612
        8.6225 11.0694 8.3575 10.8856 8.1725C10.7019 7.9875 10.4481 7.895 10.1237
        7.895C9.80375 7.895 9.54875 7.9925 9.35938 8.18687C9.17 8.38125 9.06062 8.70375
        9.0325 9.155L7.48937 9.00062C7.58062 8.15125 7.8675 7.54125 8.35063 7.17063C8.83375
        6.8 9.4375 6.61562 10.1619 6.61562C10.9556 6.61562 11.5794 6.83 12.0331 7.25812C12.4869
        7.68625 12.7137 8.21937 12.7137 8.85625C12.7137 9.21875 12.6488 9.56375 12.5188
        9.89125C12.3888 10.2188 12.1831 10.5625 11.9012 10.9206C11.7144 11.1581 11.3769
        11.5012 10.8881 11.9481C10.4 12.3944 10.0906 12.6906 9.96063 12.8369C9.83063 12.9831
        9.72563 13.1262 9.645 13.2656H12.7137V13.2663Z"
        fill="#475569"
      />
    </svg>
  );
}
